<template>
  <v-row no-gutters style="color: #353535">
    <v-dialog v-model="localDialogEdit" persistent width="620">
      <v-card style="border-radius: 20px">
        <v-card-title>
          <v-row class="pt-16" no-gutters>
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <v-col cols="10" md="10" xs="10" sm="10">
              <span style="font-size: 32px; font-weight: 500; color: #353535">
                {{ $t("shedulepage.editroom") }}
              </span>
            </v-col>
          </v-row>
        </v-card-title>

        <v-card-text>
          <v-row no-gutters>
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <v-col cols="12" md="3" xs="12" sm="12" class="mt-2">
              <span style="font-size: 20px; font-weight: 500; color: #353535">
                {{ $t("roomsetting.roomname") }} :
              </span>
            </v-col>
            <v-col cols="12" md="7" xs="12" sm="12">
              <v-text-field :rules="roomnamerules" autofocus outlined v-model="nameroom" dense
                style="font-size: 12px"></v-text-field>
            </v-col>
          </v-row>
          <!-- <v-row no-gutters>
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <v-col cols="12" md="4" xs="4" sm="4" class="mt-2">
              <span style="font-size: 18px; font-weight: 500; color: #353535;"> ลิงก์เข้าประชุม </span>
            </v-col>
            <v-col cols="9" md="5" xs="5" sm="5">
              <v-textarea
                  outlined
                  dense
                  rows="2"
                  no-resize
                  v-model="cid"
                  style="font-size: 12px;"
                  readonly
                  disabled
                ></v-textarea>
            </v-col>
            <v-col cols="1" md="1" xs="1" sm="1" class="pl-7">
              <v-btn
              outlined
              block
              @click="copylink"
              color="#0B3A8F"
              >
              <v-icon dark>
               mdi-content-copy
              </v-icon></v-btn>
            </v-col>
            <input
                  type="hidden"
                  v-model="txtLink"
                  id="txtLink"
                  ref="txtLink"
                />
            </v-row> -->
          <!-- <v-row no-gutters class="mt-n7">
            <v-col cols="0" md="5" xs="5" sm="5"></v-col>
            <v-col cols="12" md="7" xs="7" sm="7">
              <span style="font-size: 14px; color: #CCCCCC;">
                *คุณสามารถคัดลอกลิงค์นี้ส่งต่อเพื่อเชิญเข้าร่วมประุชม </span>
            </v-col>
            </v-row> -->
          <v-row no-gutters>
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <v-col cols="12" md="2" sm="12" xs="12" class="pt-2">
              <span style="font-size: 20px; font-weight: 500; color: #353535">
                {{ $t("button.btnstart") }} :
              </span>
              <!-- Date and time -->
            </v-col>
            <v-col cols="12" md="4" sm="12" xs="12" class="pr-2">
              <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="45" transition="scale-transition"
                offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="displayDate" readonly v-bind="attrs" v-on="on" outlined dense></v-text-field>
                </template>
                <v-date-picker :min="minDate" v-model="date" @input="menu = false">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4" sm="12" xs="12" class="pr-2">
              <vue-timepicker v-model="time" input-width="100%" input-height="100px" input-class="time-custom"
                :hour-range="showHour ? [[minHour, 23]] : [[1, 24]]"
                :minute-range="showMinute ? rangeMinMinute : [[0, 59]]">
                <v-icon />
              </vue-timepicker>
              <label for="default-picker"> </label>
            </v-col>
          </v-row>
          <v-row no-gutters>
            <v-col cols="1" md="1" xs="1" sm="1"></v-col>
            <v-col cols="12" md="2" sm="12" xs="12" class="pt-2">
              <span style="font-size: 20px; font-weight: 500; color: #353535">
                {{ $t("button.btnend") }} :
              </span>
              <!-- Date and time -->
            </v-col>
            <v-col cols="12" md="4" sm="12" xs="12" class="pr-2">
              <v-menu v-model="datetimeend" :close-on-content-click="false" :nudge-right="45"
                transition="scale-transition" offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field :value="displayDateEnd" readonly v-bind="attrs" v-on="on" outlined dense></v-text-field>
                </template>
                <v-date-picker :min="minDateend" v-model="dateend" @input="datetimeend = false">
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="4" sm="12" xs="12" class="pr-2">
              <vue-timepicker v-model="timeend" input-width="100%" input-height="100px" input-class="time-custom"
                :hour-range="showHourend ? [[minHourend, 23]] : [[1, 24]]"
                :minute-range="showMinuteend ? rangeMinMinuteend : [[0, 59]]">
                <v-icon />
              </vue-timepicker>
              <label for="default-picker"> </label>
            </v-col>
          </v-row>
          <v-row class="pb-2">
            <v-col cols="1" md="1" sm="1" sx="1"></v-col>
            <v-col cols="12" md="10" sm="10" sx="10" class="mt-n4 mb-n4">
              <v-btn text class="no-uppercase p-0 m-0"
                style="color: #3d85c6; font-size: 20px; text-decoration: underline" @click="clickToShowOptions">{{
                  $t("roomsetting.setting") }}</v-btn>
              <v-icon style="color: #3d85c6" @click="clickToShowOptions">
                mdi-chevron-down
              </v-icon>
            </v-col>
          </v-row>
          <div v-if="showOptions">
            <v-form ref="form">
              <v-row no-gutters class="mt-4" v-if="false">
                <v-col cols="1" md="1" xs="1" sm="1"></v-col>
                <v-col cols="12" md="4" xs="4" sm="4" class="mt-2">
                  <span style="font-size: 18px; font-weight: 500; color: #353535">
                    เว็บไคลเอ็นต์
                  </span>
                </v-col>
                <v-col cols="12" md="7" xs="7" sm="7">
                  <v-text-field outlined dense disabled v-model="datatype"></v-text-field>
                  <!-- <v-select
                  :items="web"
                  label="OneRTC (recommend)"
                  outlined
                  v-model="datatype"
                  dense
                  ></v-select> -->
                </v-col>
              </v-row>
              <v-form ref="form">
                <v-row no-gutters class="mb-n2">
                  <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                  <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                    <span style="font-size: 18px; font-weight: 500; color: #353535">{{
                      $t("roomsetting.passwordrooms")
                    }}</span>
                  </v-col>
                  <v-col cols="12" md="6" sm="6" xs="6">
                    <!-- :rules="[filterInput]" -->
                    <v-text-field outlined clearable dense v-model="key" @keypress="userpassword"
                      append-icon="mdi-dice-multiple" @click:append="clickToAddPassword"></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
              <v-row no-gutters class="mb-n2" v-if="false">
                <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                  <span style="font-size: 18px; font-weight: 500; color: #353535">ลิงก์โหวตสำหรับผู้เข้าร่วม</span>
                </v-col>
                <v-col cols="12" md="6" sm="6" xs="6">
                  <v-text-field outlined dense v-model="linkVote"></v-text-field>
                </v-col>
              </v-row>
            </v-form>
            <!-- <v-row no-gutters class="mb-n2" v-if="false">
              <v-col cols="12" md="5" sm="12" xs="12" class="pt-2">
                <span style="font-size: 16px; color:red;">*</span><span style="font-size: 16px;">vender</span>
                </v-col>
              <v-col cols="12" md="6" sm="12" xs="12">
                <v-select
                  :items="venders"
                  dense
                  outlined
                  item-text="name"
                  item-value="name"
                  style="font-size: 10px;"
                  v-model="vender"
                  placeholder="กรุณาเลือก"
                  persistent-placeholder
                ></v-select>
              </v-col>
            </v-row> -->
            <v-row no-gutters v-if="this.users.role != 'default'">
              <v-col cols="0" md="1" sm="1" sx="1"></v-col>
              <v-switch v-model="secretroom" inset rounded dense color="#64DD17"></v-switch>
              <span style="font-size: 16px; display: flex; align-items: center">{{
                $t("roomsetting.secretmeeting")
              }}</span>
            </v-row>
            <!-- <div v-if="secretroom">
            <v-form ref="form">
              <v-row no-gutters class="mb-n2">
                <v-col cols="1" md="1" sm="1" sx="1"></v-col>
                <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                  <span style="font-size: 16px;">กรุณาระบุ LOA</span>
                </v-col>
                <v-col cols="12" md="6" sm="6" xs="6">
                  <v-select
                  :items="loa"
                  label="กรุณาเลือก LOA ผู้เข้าร่วมประชุม"
                  outlined
                  v-model="secelctloa"
                  dense
                  ></v-select>
                </v-col>
              </v-row>
            </v-form>
          </div> -->
            <v-row no-gutters class="mt-n5">
              <v-col cols="0" md="1" sm="1" sx="1"></v-col>
              <v-switch v-model="stateLockRoom" inset rounded dense color="#64DD17"></v-switch>
              <span style="font-size: 16px; display: flex; align-items: center">{{
                $t("roomsetting.lock")
              }}</span>
            </v-row>
            <v-row no-gutters class="mt-n5">
              <v-col cols="0" md="1" sm="1" sx="1"></v-col>
              <v-switch v-model="Allowguest" inset rounded dense color="#64DD17"></v-switch>
              <span style="font-size: 16px; display: flex; align-items: center">{{
                $t("roomsetting.anonymous")
              }}</span>
            </v-row>
          </div>
          <v-row class="pb-2">
            <v-col cols="1" md="1" sm="1" sx="1"></v-col>
            <v-col cols="12" md="10" sm="10" sx="10" class="mt-n3 mb-n4">
              <v-btn text class="no-uppercase p-0 m-0"
                style="color: #3d85c6; font-size: 20px; text-decoration: underline" @click="clickToShowOptionsmail">{{
                  $t("roomsetting.invitemail") }}</v-btn>
              <v-icon style="color: #3d85c6" @click="clickToShowOptionsmail">
                mdi-chevron-down
              </v-icon>
            </v-col>
          </v-row>
          <div v-if="showOptionsmail">
            <v-row no-gutters class="mb-n2">
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                <span style="font-size: 18px; font-weight: 500; color: #353535">{{ $t("roomsetting.subject") }} :
                </span>
                <!-- Mail subject -->
              </v-col>
              <v-col cols="12" md="6" sm="6" xs="6">
                <v-text-field outlined dense v-model="subject" style="font-size: 12px"></v-text-field>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                <span style="font-size: 18px; font-weight: 500; color: #353535">{{ $t("loginpage.resendemail") }}
                  :</span>
                <!-- Send mail to -->
              </v-col>
              <v-col cols="12" md="6" sm="6" xs="6">
                <!-- <v-autocomplete
                chips
                clearable
                outlined
                v-model="email"
                :items="items"
                deletable-chips
                multiple
                small-chips
              ></v-autocomplete> -->
                <v-autocomplete v-model="emailnew" :label="this.$t('message.Selectemail')" :items="items" outlined
                  persistent-hint :hint="this.$t('message.Emailsent')" chips clearable deletable-chips multiple
                  small-chips>
                  <template v-slot:selection="data">
                    <v-chip :key="JSON.stringify(data.item)" v-bind="data.attrs" :input-value="data.selected"
                      :disabled="data.disabled" @click:close="data.parent.selectItem(data.item)">
                      <v-avatar class="accent white--text" left v-text="data.item.slice(0, 1).toUpperCase()"></v-avatar>
                      {{ data.item }}
                      <v-icon small @click="data.parent.selectItem(data.item)">
                        $delete
                      </v-icon>
                    </v-chip>
                  </template>
                </v-autocomplete>
                <!-- <v-combobox
                  v-model="emailnew"
                  :items="items"
                  label="Email : example.ex@inet.co.th"
                  multiple
                  outlined
                  chips>
          <template v-slot:selection="data">
            <v-chip
              :key="JSON.stringify(data.item)"
              v-bind="data.attrs"
              :input-value="data.selected"
              :disabled="data.disabled"
              @click:close="data.parent.selectItem(data.item)"
            >
              <v-avatar
                class="accent white--text"
                left
                v-text="data.item.slice(0, 1).toUpperCase()"
              ></v-avatar>
              {{ data.item }}
                <v-icon
              small
              @click="data.parent.selectItem(data.item)"
            >
              $delete
            </v-icon>
            </v-chip>
          </template>
        </v-combobox> -->
              </v-col>
            </v-row>
            <v-row no-gutters class="mb-n2">
              <v-col cols="1" md="1" sm="1" xs="1"></v-col>
              <v-col cols="12" md="4" sm="4" xs="4" class="pt-2">
                <span style="font-size: 18px; font-weight: 500; color: #353535">{{ $t("message.Addyouremail") }} :
                </span>
              </v-col>
              <v-col cols="12" md="6" sm="6" xs="6">
                <v-text-field outlined dense v-model="email" type="email" persistent-hint
                  :hint="this.$t('message.Addemail')" small-chips
                  label="example.ex@gmail.com,example.ex@inet.co.th"></v-text-field>
              </v-col>
            </v-row>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-col cols="2" md="2" xs="2" sm="2"></v-col>
          <v-col cols="4" md="4" xs="4" sm="4">
            <v-btn block rounded color="error" @click="closeeditschedule">{{ $t("button.btncancel") }}
            </v-btn>
          </v-col>
          <v-col cols="4" md="4" xs="4" sm="4">
            <v-btn block style="color: white" :disabled="!validTime" rounded color="#3D85C6" @click="checkloa">{{
              $t("button.btnok")
            }}</v-btn>
          </v-col>
          <v-col cols="2" md="2" xs="2" sm="2"></v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import VueTimepicker from "vue2-timepicker";

export default {
  components: {
    VueTimepicker,
  },
  create() {
    window.moment = moment;
  },
  data() {
    return {
      jwt: require("jsonwebtoken"),
      showOptions: false,
      showOptionsmail: false,
      key: "",
      validTime: true,
      roomnamerules: [
        (v) => !!v || this.$t("loginpage.Pleasespecify"),
        (v) => /^[^ ]+/.test(v) || this.$t("loginpage.checkspace"),
      ],
      onlyNumber: "this.value = this.value.replace(/[^0-9a-zA-Z!@#$%&*~+-฿/?]|/g, '')",
      // loa: ['LV.1', 'LV.2', 'LV.3', 'LV.4'],
      // select: [],
      items: [],
      secelctloa: "",
      nameroom: "",
      subject: "",
      linkVote: "",
      email: "",
      emailnew: "",
      timeend: null,
      avgemail: "",
      search: null,
      time: null,
      datatype: "",
      // web: ['PxStandard', 'OneRTC'],
      web: ["OneRTC"],
      secretroom: false,
      Allowguest: true,
      meetid: "",
      menu: false,
      datetimeend: false,
      date: null,
      dateend: null,
      showHour: true,
      showHourend: true,
      showMinute: true,
      showMinuteend: true,
      minDate: moment().format("YYYY-MM-DD"),
      minDateend: moment().format("YYYY-MM-DD"),
      minCurrent: moment().format("YYYY-MM-DD"),
      minHourend: moment().format("HH"),
      minHour: moment().format("HH"),
      minMinute: moment().format("mm"),
      rangeMinMinute: [[moment().format("mm"), 59]],
      rangeMinMinuteend: [[moment().format("mm"), 59]],
      currentDate: moment().format("DD-MM-YYYY"),
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  // mounted() {
  //   console.log('mounted editschedule')
  //   console.log('dataedit', this.datarditroom)
  // },
  watch: {
    Allowguest(value) {
      if (value) {
        this.secretroom = false;
        // this.login = true
      }
    },
    secretroom(value) {
      if (value) {
        this.Allowguest = false;
        // this.login = false
      }
    },
    editschedule(value, oldValue) {
      // console.log('dataedit', this.datarditroom)
      // console.log('value', value)
      // console.log('oldValue', oldValue)
      if (value !== oldValue && value) {
        // var roleEncrypt = localStorage.getItem('role')
        // const decryptedText = this.CryptoJS.AES.decrypt(
        //   roleEncrypt,
        //   'One Conference'
        // ).toString(this.CryptoJS.enc.Utf8)
        // this.role = decryptedText
        this.decodeToken();
        // console.log('value !== oldValue', this.datarditroom)
        this.data = this.datarditroom;
        this.items = this.datarditroom.setting.sended_mails;
        // console.log('value !== oldValue',this.items)
        this.Start = this.datarditroom.started;
        var d1 = this.data.setting.enddate.substr(0, 2);
        var m1 = this.data.setting.enddate.substr(3, 2);
        var y1 = this.data.setting.enddate.substr(6, 4);
        var newdateend = y1 + "-" + m1 + "-" + d1;
        this.dateend = newdateend;
        // console.log('newdateend', this.dateend)
        var d = this.data.setting.startdate.substr(0, 2);
        var m = this.data.setting.startdate.substr(3, 2);
        var y = this.data.setting.startdate.substr(6, 4);
        var newdate = y + "-" + m + "-" + d;
        // console.log('newdate', newdate)
        this.date = newdate;
        var timestart = this.data.setting.startdate.substr(11, 6);
        var timeend = this.data.setting.enddate.substr(11, 6);
        // console.log('timeend', timeend)
        // console.log('this.date', this.date)
        this.time = timestart;
        this.timeend = timeend;
        // this.date = this.data.start_date
        this.nameroom = this.data.roomname;
        this.cid = this.data.urlInvite;
        this.stateLockRoom = this.data.setting.meetingLock;
        this.secretroom = this.data.setting.secretroom;
        this.Allowguest = this.data.setting.login;
        this.meetid = this.data.meeting_id;
        if (this.data.loa === 1) {
          this.secelctloa = "LV.1";
        } else if (this.data.loa === 2) {
          this.secelctloa = "LV.2";
        } else if (this.data.loa === 3) {
          this.secelctloa = "LV.3";
        } else if (this.data.loa === 4) {
          this.secelctloa = "LV.4";
        } else {
          this.secelctloa = "";
        }
        // this.secelctloa = this.data.loa
        this.datatype = this.data.type;
        if (this.data.key === "123roominet!") {
          this.key = "";
        } else if (
          this.secelctloa !== null ||
          this.secretroom !== false ||
          this.data.key !== "123roominet!"
        ) {
          this.showOptions = true;
          let splitKey = this.data.key.split(":inet!");
          this.key = splitKey[0];
        } else {
          this.showOptions = false;
        }
        this.meetid = this.data.meeting_id;
      }
    },
    time(value, oldValue) {
      if (value >= "23.00") {
        if (this.dateend <= this.date) {
          var newdatetime = new Date(this.date);
          newdatetime.setDate(newdatetime.getDate() + 1);
          this.dateend = moment(newdatetime).format("YYYY-MM-DD");
        }
      }
      if (value !== oldValue) {
        this.newtime = value;
        this.timeend = moment(this.newtime, "HH:mm").add(1, "h").format("HH:mm");
        const splitTime = this.time.split(":");
        // console.log('time', this.minHour)
        if (splitTime[0] > this.minHour) {
          this.rangeMinMinute = [[0, 59]];
        } else {
          this.rangeMinMinute = [[moment().format("mm"), 59]];
        }
      }
    },
    timeend(value, oldValue) {
      if (value !== oldValue) {
        const splitTime = this.timeend.split(":");
        this.minHourend = this.newtime.slice(0, 2)
        console.log(this.newtime.slice(3, 5));
        if (splitTime[0] != this.minHourend) {
          this.rangeMinMinuteend = [[0, 59]];
        } else {
          const int = parseInt(this.newtime.slice(3, 5)) + 1;
          this.rangeMinMinuteend = [[int, 59]];
          if (parseInt(value.slice(3, 5)) === parseInt(this.newtime.slice(3, 5))) {
            this.validTime = false;
          } else {
            this.validTime = true;
          }
          // console.log(this.rangeMinMinute)
        }
      }
    },
    dateend(value, oldValue) {
      this.minCurrent = value;
      if (value !== this.minDateend) {
        this.showHourend = false;
        this.showMinuteend = false;
      } else {
        this.showHourend = true;
        this.showMinuteend = true;
      }
    },
    date(value, oldValue) {
      // console.log('value', value , oldValue)
      if (value !== this.minCurrent) {
        this.showHourend = false;
        this.showMinuteend = false;
      } else {
        this.showHourend = true;
        this.showMinuteend = true;
      }
      this.minDateend = moment(value).format("YYYY-MM-DD");
      if (value !== moment().format("YYYY-MM-DD") && value !== oldValue) {
        if (this.time >= "23.00") {
          if (this.dateend <= this.date) {
            var newdatetime = new Date(this.date);
            newdatetime.setDate(newdatetime.getDate() + 1);
            this.dateend = moment(newdatetime).format("YYYY-MM-DD");
          }
        } else {
          if (value >= this.dateend) {
            this.dateend = value;
          }
        }
        this.showHour = false;
        this.showMinute = false;
      } else {
        if (this.time >= "23.00") {
          if (this.dateend <= this.date) {
            var newdatetime = new Date(this.date);
            newdatetime.setDate(newdatetime.getDate() + 1);
            this.dateend = moment(newdatetime).format("YYYY-MM-DD");
          }
        } else {
          if (value >= this.dateend) {
            this.dateend = value;
          }
        }
        this.showHour = true;
        this.showMinute = true;
      }
    },
  },
  computed: {
    ...mapState("dialog", ["editschedule", "datarditroom"]),
    displayDate() {
      return moment(this.date).format("DD-MM-YYYY");
    },
    displayDateEnd() {
      return moment(this.dateend).format("DD-MM-YYYY");
    },
    localDialogEdit: {
      get() {
        return this.editschedule;
      },
      set(value) {
        this.setDialogScheduleEdit(value);
      },
    },
  },
  methods: {
    ...mapActions("dialog", ["setDialogScheduleEdit"]),
    filterInput(value) {
      // Custom rule to check for any character without "number or English"
      const regex = /^[a-zA-Z0-9!@#$%^&*+=._-]+$/;
      return regex.test(value) || this.$t("roomsetting.alertpass");
    },
    userpassword(e) {
      // only english and number
      const key = e.which ? e.which : e.keyCode;
      if (key >= 33 && key <= 64) {
        return true;
      } // number
      if (key >= 65 && key <= 90) {
        return true;
      } // A-Z
      if (key >= 91 && key <= 125) {
        return true;
      } // a-z
      return e.preventDefault();
    },
    goPage(link) {
      this.$router.push(link).catch(() => { });
    },
    clickToShowOptions() {
      this.showOptions = !this.showOptions;
      // this.clickToAddPassword()
    },
    clickToShowOptionsmail() {
      this.showOptionsmail = !this.showOptionsmail;
    },
    clickToAddPassword() {
      this.key = this.randomPassword(2);
      // console.log('clickToAddPassword', this.key)
    },
    filterKey(e) {
      const key = e.which ? e.which : e.keyCode;
      if (key > 31 && (key < 48 || key > 57)) {
        return e.preventDefault();
      }
    },
    randomPassword(length) {
      var chars = "abcdefghijklmnopqrstuvwxyz";
      var char = "QWERTYUIOPLKJHGFDSAZXCVBNM";
      var number = "1234567890";
      var characters = "!@#$%^&*+=._-";
      var pass = "";
      var pass1 = "";
      var pass2 = "";
      var pass3 = "";
      var pass4 = "";
      for (var x = 0; x < length; x++) {
        pass += chars.charAt(Math.floor(Math.random() * chars.length));
        pass1 += number.charAt(Math.floor(Math.random() * number.length));
        pass2 += char.charAt(Math.floor(Math.random() * char.length));
        pass3 += characters.charAt(Math.floor(Math.random() * characters.length));
        pass4 = pass + pass1 + pass2 + pass3;
      }
      return pass4;
    },
    decodeToken() {
      if (localStorage.getItem("user-token") !== null) {
        var token = localStorage.getItem("user-token");
        const decryptedText = this.CryptoJS.AES.decrypt(
          token,
          process.env.VUE_APP_SECRET_KEY
        )
          .toString(this.CryptoJS.enc.Utf8)
          .replace(/"/g, "");
        var data = this.jwt.decode(decryptedText);
        // console.log('decode data', data)
        this.users = data.user;
        // this.room = data.room
        // this.secretroom = this.room.setting.secretroom
        // this.userData = data
        // if (this.userData.service.service === 'dga') {
        //   this.closeForDga = false
        // }
      }
    },
    checkloa() {
      if (this.scheduleroom === "") {
        this.$swal(
          this.$t("loginpage.Pleasespecify"),
          this.$t("roomsetting.roomname"),
          "warning"
        );
      } else if (this.showOptions === true) {
        if (this.secretroom === true) {
          if (this.secelctloa === "LV.2") {
            this.secelctloa = 2;
          } else if (this.secelctloa === "LV.3") {
            this.secelctloa = 3;
          } else if (this.secelctloa === "LV.4") {
            this.secelctloa = 4;
          } else {
            this.secelctloa = 1;
          }
        } else {
          this.secelctloa = "";
        }
      } else {
        //comment for other case edit schedule was Default setting
        // this.key = "";
        // this.secretroom = false;
        // this.secelctloa = "";
        // this.Allowguest = true;
      }
      this.updateSchedule();
      // console.log('this.email', this.email)
    },
    closeeditschedule() {
      this.localDialogEdit = false;
    },
    async updateSchedule() {
      if (this.email !== "" || this.emailnew !== "") {
        this.avgemail = [this.email + "," + this.emailnew];
      } else {
        this.avgemail = "";
      }
      // console.log('this.avgemail', this.avgemail)
      if (this.Start === true) {
        this.$swal(this.$t("message.closmeetingandopen"), "", "warning");
      } else {
        if (this.secelctloa === null) {
          this.secelctloa = "";
        } else if (this.showOptions === false || this.secretroom === false) {
          this.secelctloa = "";
        }
        const payload = {
          email: this.avgemail,
          meeting_id: this.meetid,
          name: this.nameroom,
          starttime: this.time,
          startdate: this.date,
          endtime: this.timeend,
          enddate: this.dateend,
          key: this.key === null ? '' : this.key,
          secretroom: this.secretroom,
          meetingLock: this.stateLockRoom,
          login: this.Allowguest,
          loa: this.secelctloa,
          // time: this.time,
          // date: this.date,
          subject: this.subject,
          type: this.datatype,
          vote: [this.linkVote],
        };
        // console.log('payload', payload)
        if (this.nameroom === "") {
          this.$swal(
            this.$t("loginpage.Pleasespecify"),
            this.$t("roomsetting.roomname"),
            "warning"
          );
        } else if (this.time === "") {
          this.$swal(
            this.$t("loginpage.Pleasespecify"),
            this.$t("message.time"),
            "warning"
          );
        } else {
          try {
            const url = process.env.VUE_APP_API + "/api/lv1/room/update";
            const response = await this.axios.put(url, payload);
            this.setDialogScheduleEdit(false);
            this.$swal(
              this.$t("loginpage.update") + this.$t("table.roomsname"),
              "",
              "success"
            );
            this.email = [];
            this.emailnew = [];
            this.subject = "";
          } catch (error) {
            console.log("updateschedule: ", error);
          }
        }
      }
    },
  },
};
</script>
